<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero
        span 3
      h1 Ejecución del sistema de monitoreo
    img(data-aos="fade-up")(src="@/assets/curso/temas/tema3/1.png", alt="Imagen decorativa")

    .row.justify-content-center.mb-4
      .col-lg-10.col-xl-8(data-aos="fade-down")
        div.banner-text.bg-white
          p.mb-0 Ejecutar el sistema de monitoreo implica pasar de la planeación a la acción, es el momento en que se activan los indicadores, se utilizan las herramientas definidas y se aplican los formatos que permiten registrar, analizar y comunicar el progreso de las acciones de mercadeo. 

    .row.justify-content-center
      .col-lg-10.col-xl-8
        .p-4.bg-color-acento-contenido-ac20.rounded-4
          p.text-center.mb-0 Este capítulo presenta los elementos clave para una ejecución efectiva, incluyendo la periodicidad, los responsables y los criterios técnicos que garantizan trazabilidad y mejora continua.
    Separador
    #t_3_1(data-aos='zoom-in-right').titulo-segundo.color-acento-contenido
      h3 3.1 Uso de indicadores

    .fullwidth-bg.fullwidth-bg--2
    .row.align-items-center.mb-5.justify-content-center.justify-content-lg-start
      .col-sm-6.col-md-8.col-lg-5.col-xl-4
        figure
          img.mb-4.mb-lg-0(src="@/assets/curso/temas/tema3/2.png", alt="Imagen decorativa", data-aos="zoom-in-left")
      .col-lg-7
        p.mb-0 Los indicadores clave de desempeño (<em>KPIs</em>) son métricas específicas que permiten evaluar el cumplimiento de los objetivos estratégicos, según Chaffey & Ellis-Chadwick (2019), un <em>KPIs</em> debe ser relevante, medible, accionable y alineado con el propósito de la acción. En mercadeo, algunos <em>KPIs</em> comunes incluyen: tasa de conversión, alcance digital, retorno sobre inversión (ROI), tasa de fidelización, participación de mercado, entre otros. Por ejemplo, una empresa de educación virtual puede usar como <em>KPIs</em> el porcentaje de estudiantes que completan el curso, comparado con los inscritos. 

    .row.justify-content-center.align-items-center.z-2.mb-5
      .col-lg-10.col-xl-9
        .titulo-sexto.color-acento-contenido.mb-4
          h5 Figura 3.
          span Ejemplos de <em>KPIs</em> aplicados a acciones de mercadeo
        img.mb-2.d-sm-none(data-aos="fade-up", src='@/assets/curso/temas/tema3/3-mob.svg', alt='La figura muestra cuatro ejemplos de KPIs aplicados a acciones de mercadeo.')
        img.mb-2.d-none.d-sm-block(data-aos="fade-up", src='@/assets/curso/temas/tema3/3.svg', alt='La figura muestra cuatro ejemplos de KPIs aplicados a acciones de mercadeo.')
        figcaption <strong>Fuente:</strong> Adaptado de Chaffey & Ellis-Chadwick, 2019.

    Separador
    #t_3_2(data-aos='zoom-in-right').titulo-segundo.color-acento-contenido
      h3 3.2 Herramientas

    p.mb-5 Las herramientas de seguimiento permiten recolectar, visualizar y analizar los datos generados por las acciones de mercadeo, algunas de las más utilizadas son:

    .row.justify-content-center.z-2.mb-4.mb-lg-5
      .col-sm-6.col-xl-3.mb-4.mb-xl-0
        .crd_hover_txt(data-aos="flip-left")
          .crd_hover_txt--img
            figure
              img(data-aos="fade-down")(src="@/assets/curso/temas/tema3/4.png", alt="Imagen decorativa")
          .crd_hover_txt--body.bg-color-primario-p5
            h4.mb-4.text-center Google Analytics
            p.text-center Para monitorear tráfico web, comportamiento del usuario y conversiones.

      .col-sm-6.col-xl-3.mb-4.mb-xl-0
        .crd_hover_txt(data-aos="flip-left")
          .crd_hover_txt--img
            figure
              img(data-aos="fade-down")(src="@/assets/curso/temas/tema3/5.png", alt="Imagen decorativa")
          .crd_hover_txt--body.bg-color-primario-p5
            h4.mb-4.text-center CRM (<em>Customer Relationship Management</em>)
            p.text-center Para registrar interacciones con clientes y medir fidelización.

      .col-sm-6.col-xl-3.mb-4.mb-xl-0
        .crd_hover_txt(data-aos="flip-left")
          .crd_hover_txt--img
            figure
              img(data-aos="fade-down")(src="@/assets/curso/temas/tema3/6.png", alt="Imagen decorativa")
          .crd_hover_txt--body.bg-color-primario-p5
            h4.mb-4.text-center Tableros de control
            p.text-center Visualizan <em>KPIs</em> en tiempo real, facilitando la toma de decisiones.

      .col-sm-6.col-xl-3
        .crd_hover_txt(data-aos="flip-left")
          .crd_hover_txt--img
            figure
              img(data-aos="fade-down")(src="@/assets/curso/temas/tema3/7.png", alt="Imagen decorativa")
          .crd_hover_txt--body.bg-color-primario-p5
            h4.mb-4.text-center Hojas de cálculo estructuradas
            p.text-center Permiten registrar manualmente datos de campañas, eventos o acciones presenciales.

    .row.justify-content-center.align-items-center.mb-5
      .col-xl-10
        .p-4.bg-box.rounded-4
          .row.align-items-center.justify-content-center
            .col-lg-9
              p.mb-0 Por ejemplo, una empresa de moda puede usar Google Analytics para rastrear el impacto de una campaña de <em>email marketing</em>, mientras que su CRM le permite identificar qué clientes respondieron y realizaron compras, cada herramienta debe seleccionarse según el tipo de acción, el canal utilizado y los recursos disponibles.
            .d-none.d-lg-block.col-lg-2
              figure
                img(src="@/assets/curso/temas/tema3/8.png" alt="Imagen ilustrativa" data-aos="fade-up")

    Separador
    #t_3_3(data-aos='zoom-in-right').titulo-segundo.color-acento-contenido
      h3 3.3 Periodicidad


    .row.align-items-center.mb-5.justify-content-center.justify-content-lg-start.z-2
      .col-sm-6.col-md-8.col-lg-5.col-xl-4
        figure
          img.mb-4.mb-lg-0(src="@/assets/curso/temas/tema3/9.png", alt="Imagen decorativa", data-aos="zoom-in-left")
      .col-lg-7
        p La periodicidad se refiere a la frecuencia con la que se realiza el monitoreo, esta puede ser diaria, semanal, mensual o por evento, dependiendo del tipo de acción y del ritmo del mercado. Según Kotler & Keller (2016), una medición oportuna permite ajustes rápidos y decisiones más efectivas.
        p.mb-0 Los responsables del monitoreo pueden ser analistas de mercadeo, coordinadores de campaña, equipos de ventas o personal de atención al cliente, es fundamental que cada responsable conozca los indicadores asignados, las herramientas que debe usar y los formatos de reporte.
    
    .row.justify-content-center.align-items-center.mb-5.z-2
      .col-xl-10
        .p-4.py-lg-0.bg-box.rounded-4
          .row.align-items-center.justify-content-center
            .col-lg-9
              p.mb-0 Por ejemplo, en una campaña de lanzamiento de producto, el monitoreo puede ser diario durante las dos primeras semanas, con reportes semanales al equipo directivo.
            .d-none.d-lg-block.col-lg-2
              figure
                img(src="@/assets/curso/temas/tema3/10.png" alt="Imagen ilustrativa" data-aos="fade-up")

    .fullwidth-bg.fullwidth-bg--2
    Separador
    #t_3_4(data-aos='zoom-in-right').titulo-segundo.color-acento-contenido
      h3 3.4 Formatos de evaluación

    .row.align-items-center.z-2.mb-4
      .col-md-6.col-lg-5
        figure
          img.mb-4.mb-lg-0(src="@/assets/curso/temas/tema3/11.png", alt="Imagen decorativa", data-aos="zoom-in-left")
      .col-lg-6
        p Los formatos de evaluación son documentos o plantillas que permiten registrar los resultados obtenidos, compararlos con las metas y generar observaciones, algunos formatos comunes incluyen:
        .p-4.bg-color-secundario-s5.rounded-4
          .row.align-items-center
            .col-md-7
              ul.lista-ul--color
                li.d-flex 
                  i.fa-solid.fa-circle-check
                  | Ficha de seguimiento por acción.
                li.d-flex
                  i.fa-solid.fa-circle-check
                  | Informe de resultados por canal.
                li.d-flex
                  i.fa-solid.fa-circle-check
                  | Matriz de cumplimiento de <em>KPIs</em>.
                li.d-flex
                  i.fa-solid.fa-circle-check
                  | Reporte de desviaciones y ajustes.
            .d-none.d-md-block.col-md-5
              figure
                img.w-89(src="@/assets/curso/temas/tema3/12.svg" alt="Imagen ilustrativa" data-aos="fade-up")

    .row.justify-content-center.z-2.mb-5
      .col-xl-10
        .cajon.color-secundario.p-4
          p.mb-0 Estos formatos deben ser claros, accesibles y adaptables, por ejemplo, una empresa de servicios puede usar una matriz de cumplimiento para comparar el número de citas agendadas con las efectivamente realizadas, identificando brechas y causas.

    .titulo-sexto.color-acento-contenido.z-2
      h5 Tabla 4.
      span Ejemplo de matriz de cumplimiento de <em>KPIs</em>
    .tabla-a.color-secundario.z-2.mb-5
      table
        caption <strong>Fuente:</strong> SENA, 2025.
        thead(style="background-color: #FFF3EF;")
          tr
            th Acción de mercadeo
            th <em>KPI</em> esperado
            th Resultado obtenido
            th Desviación
            th Observaciones
        tbody
          tr
            td <strong>Campaña en redes sociales.</strong>
            td 5.000 interacciones.
            td 4.200
            td - 800
            td Ajustar horario de publicación.
          tr
            td <strong><em>Email marketing.</em></strong>
            td 15 % tasa de apertura.
            td 18 %
            td + 3 %
            td Segmentación efectiva.
          tr
            td <strong>Evento presencial.</strong>
            td 100 asistentes.
            td 85.
            td - 15
            td Reforzar convocatoria previa.

    .row.justify-content-center
      .col-xl-10
        h4(data-aos='zoom-in-right').mb-5
          span.etiqueta-title Cita de reflexión

    .row.justify-content-center
      .col-xl-10
        .bloque-texto-f.color-acento-contenido.pt-4.px-5
          .bloque-texto-f__comillas
            i.fas.fa-quote-left
            i.fas.fa-quote-right
          .row.justify-content-center
            .col-lg-11
              p.bloque-texto-f__texto Monitorear con responsabilidad es reconocer que cada dato representa una decisión, y cada decisión, una oportunidad para servir con excelencia.
</template>

<script>
export default {
  name: 'Tema3',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
